import * as type from './types';
import { createReducer } from "../../util/index";

const initialState = 
{
    // data: [],
};

const bettingHistoryReducer = createReducer(initialState) ({
    //Export the response to the react.js to get the response data based on type name
    [type.BETTINGHISTORY_LIST]: (state, action) => ({
        ...state,
        rs: action.value
    }),
    [type.BETTINGHISTORY_CANCEL]: (state, action) => ({
        ...state,
        cancel: action.value
    }),
    [type.BETTINGHISTORY_DROPDOWN]: (state, action) => ({
        ...state,
        dropDown: action.value
    }),
    [type.SET_USER_BASICS]: (state, action) => ({
        ...state,
        userBasics: action.value
    }),
    [type.SET_USER_BASICS_FAIL]: (state, action) => ({
        ...state,
        res: action.value
    }),
});

export default bettingHistoryReducer;